
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import timeGridPlugin from '@fullcalendar/timegrid';

import { dayjs } from '../core/dayjs/dayjs';

export const calendarPlugins = [
    dayGridPlugin,
    timeGridPlugin,
    resourceTimelinePlugin,
    interactionPlugin,
];

export interface CalendarDateRange {
    startDate: string;
    endDate: string;
}

export const getMonthRange = (date = dayjs()): CalendarDateRange => ({
    startDate: date.startOf('month').format('YYYY-MM-DD'),
    endDate: date.endOf('month').format('YYYY-MM-DD'),
});

export const dateMapHasRange = (
    dateMap: Record<string, unknown>,
    startDate: string,
    endDate: string,
): boolean => {
    let current = dayjs(startDate);
    const end = dayjs(endDate);

    while (current.isBefore(end) || current.isSame(end, 'day')) {
        if (!dateMap[current.format('YYYY-MM-DD')]) {
            return false;
        }

        current = current.add(1, 'day');
    }

    return true;
};
